import { Component, OnInit, ViewChild } from '@angular/core';
import { CompanySeasonality, Product, ProductWarehouseSeasonality, Warehouse } from 'src/app/models';
import { ProductsStorageService } from '../../product-storage.service';
import { MasterApiService } from 'src/app/services/master-api.service';
import { firstValueFrom } from 'rxjs';
import { GenericResource } from 'src/app/resources';
import { ProductsWarehousesAddComponent } from '../products-warehouses-add/products-warehouses-add.component';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
    selector: 'app-product-seasonalities',
    templateUrl: './product-seasonalities.component.html',
    styleUrl: './product-seasonalities.component.sass',
    standalone: false
})
export class ProductSeasonalitiesComponent  implements OnInit{

  product?: Product;
  warehouses?: Warehouse[];
  companySeasonalities?: CompanySeasonality[];
  seasonalities?:GenericResource<ProductWarehouseSeasonality>;
  warehouseSeasonalities?: GenericResource<ProductWarehouseSeasonality>;
  createProductWarehouseComponent = ProductsWarehousesAddComponent;
  @ViewChild ('grid') dataGrid?: DxDataGridComponent;

  constructor(private api: MasterApiService, private productData: ProductsStorageService) { }
  
  async ngOnInit(): Promise<void> {
      this.product = this.productData.entity;
      this.warehouses = await firstValueFrom(this.productData.getWarehouses());
      this.seasonalities = this.api.resources.product.warehouseSeasonalities(this.productData.entity!.id)
      this.companySeasonalities = await firstValueFrom(this.api.resources.master.companySeasonalities(this.api.auth.userValue!.lastCompanyId!).getAll());
    }

    async editorComponentClosed() {
      await this.dataGrid?.instance.refresh();
    }
}
